import { saveToLS } from "@visiblethread/react-components";
import localhost from "apis/localhost";
import { DISCOVERY_SHRED_TO_EXCEL_LS_KEY } from "constants/discovery";
import { elements, modalTypes } from "constants/types";
import { showErrorModal } from "slices/app/actions/error";
import { hideModal } from "slices/app/actions/modals";
import { addToJobQueue, clearJobQueue } from "slices/app/appSlice";
import {
  setByContentData,
  setByContentPage,
  setLoading,
} from "slices/discovery/discoverySlice";
import { pollJobStatus } from "utils/jobs/jobUtils";

// TODO: VT-5713 - Remove this once we move the loading of byContent data to streams
// Abort controllers are only valid per request
export const getAllByContentDataAbortController = {
  controller: false,
};

export const addIndexesByContentData = (data) =>
  data.map((item, index) => ({ ...item, index: index + 1 }));

export const getAllByContentData = () => async (dispatch, getState) => {
  dispatch(setLoading({ element: elements.BY_CONTENT_VIEW, loading: true }));
  getAllByContentDataAbortController.controller = new AbortController();
  const { folderId, documentId: docId } = getState().folders;

  await localhost
    .get("/discovery/byContent/termInstances", {
      signal: getAllByContentDataAbortController.controller.signal,
      params: { folderId, docId },
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setByContentData(addIndexesByContentData(data)));
    })
    .catch((error) => {
      if (error.code !== "ERR_CANCELED") dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(
        setLoading({ element: elements.BY_CONTENT_VIEW, loading: false })
      );
    });
};

export const getByContentData =
  (folderId, documentId, limit) => async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));

    const params = {
      folderId,
      docId: documentId,
      limit,
    };

    await localhost
      .get("/discovery/byContent/termInstancesWithLimit", {
        params,
      })
      .then(async (response) => {
        const { data } = response;
        dispatch(setByContentData(addIndexesByContentData(data)));
        if (data.length === limit) dispatch(getAllByContentData());
      })
      .catch((error) => {
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(clearJobQueue());
      });
  };

export const shredToExcel =
  (documentsWithTerms, shredOptionsRequest) => async (dispatch, getState) => {
    dispatch(addToJobQueue("genericJob"));

    const { folderId } = getState().discovery.config;
    const documentView = folderId !== undefined;
    const url = `/discovery/export/${documentView ? "document" : "folder"}/shred`;

    await localhost
      .post(url, { folderId, documentsWithTerms, shredOptionsRequest })
      .then(async (response) => {
        dispatch(hideModal(modalTypes.SHRED_TO_EXCEL));
        const jobData = response.data.jobId;
        dispatch(pollJobStatus(jobData));
        dispatch(addToJobQueue("genericJob"));
        saveToLS(
          DISCOVERY_SHRED_TO_EXCEL_LS_KEY,
          JSON.stringify(shredOptionsRequest)
        );
      })
      .catch((error) => {
        dispatch(showErrorModal(error));
        dispatch(clearJobQueue());
      });
  };

export const clearByContentData = () => async (dispatch) => {
  dispatch(setByContentPage(1));
  dispatch(setByContentData([]));
};
